import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiWrench } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const ServiceSourcingMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.equinor) {
      return null;
    }

    if (
      !(
        user.roles_names.includes("View Vbuyer") &&
        user.roles_names.includes("Service Quotation - View")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="serviceSourcing"
          onClick={() => handleClick("serviceSourcing")}
          title={t("menu.serviceSourcing.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiWrench} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.serviceSourcing.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.serviceSourcing ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse in={openSubmenu.serviceSourcing} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {user.roles_names.includes("Service Quotation - View") && (
              <HybridRouteListItemButtonLink
                caption="service quotations"
                name="serviceSourcing[quotations]"
                sx={{ pl: 4 }}
                title={t("menu.serviceSourcing.submenu.quotations.title")}
                url="/vbuyer/service_quotations"
              >
                <ListItemText
                  primary={t("menu.serviceSourcing.submenu.quotations.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Service Quotation - Update") && (
              <HybridRouteListItemButtonLink
                caption="issue service purchase order"
                name="serviceSourcing[issuePurchaseOrder]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.serviceSourcing.submenu.issuePurchaseOrder.title",
                )}
                url="/vbuyer/service_quotations/issue_service_purchase_order"
              >
                <ListItemText
                  primary={t(
                    "menu.serviceSourcing.submenu.issuePurchaseOrder.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
